export default __webpack_public_path__ + "static/media/2-QUIFAITQUOI.1e6a3b9b.pdf";